import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subject, of, switchMap } from 'rxjs';
import { LegalizationDocumentDto } from 'src/app/models/dtos/legalization-document-files-dto';
import { LegalizationFileDto } from 'src/app/models/legalization-file-dto';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/messages/confirm-dialog/confirm-dialog.component';
import { FileService } from 'src/app/shared/services/file-service';
import { DocumentService } from 'src/app/data/document.service';
import { AddLegalizationInformationModalData } from '../save-info-modals/AddLegalizationInformationModalData';
import { SaveLegalizationInfoByCoordinatorComponent } from '../save-info-modals/save-legalization-info-by-coordinator/save-legalization-info-by-coordinator.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-leagalization-documents-list',
  templateUrl: './leagalization-documents-list.component.html',
  styleUrls: ['./leagalization-documents-list.component.scss'],
  standalone: false
})
export class LeagalizationDocumentsListComponent implements OnInit {
  protected dialog = inject(MatDialog);
  protected fileService = inject(FileService);
  protected documentService = inject(DocumentService);
  protected translateService = inject(TranslateService);

  @Input() workerId: number;
  @Input() legalizationDocuments: LegalizationDocumentDto[];
  @Input() showDecisionButton: boolean;
  @Input() canDeleteUnsavedLegalizationDocuments?: boolean;

  @Output() newLegalizationDocumentEvent = new EventEmitter<LegalizationDocumentDto>();
  @Output() deleteLegalizationDocumentEvent = new EventEmitter<LegalizationDocumentDto>();

  protected endpoint: string;

  protected subject = new Subject<void>();
  protected unsubscribe$ = new Subject<void>();
  protected hasDocumentsRequiringCorrection = false;

  constructor() { }

  public ngOnInit(): void {
    this.endpoint = `workers/${this.workerId}/files`;
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  public legalizationDocumentsFilter = (ld: LegalizationDocumentDto) => !!ld.Files?.length;

  public openDocumentLegalizationForCoordinator(legalizationDocumentId: number, isCorrection?: boolean): void {
    const dialogRef = this.dialog.open(
      SaveLegalizationInfoByCoordinatorComponent,
      this.dialogConfig(<AddLegalizationInformationModalData>{
        Title: 'Legalization.Title',
        LegalizationDocumentId: legalizationDocumentId,
        WorkerId: this.workerId,
        IsCorrection: isCorrection,
      }),
    );

    dialogRef.afterClosed().subscribe((result) => this.handleDialogResponse(result));
  }

  public downloadFile(id: number, name: string): void {
    this.fileService.downloadFile(id, name, this.endpoint);
  }

  public showFile(legalizationFile: LegalizationFileDto): void {
    let name = legalizationFile.Name ?? legalizationFile.OriginalName;
    this.fileService.showFile(name, legalizationFile.Id, this.endpoint, legalizationFile.FileContent);
  }

  public deleteUnsavedFile(legalizationDocument: LegalizationDocumentDto, file: LegalizationFileDto): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, this.dialogConfig(new ConfirmDialogData('Attention', 'WL-DeleteAFileQuestion')));

    dialogRef
      .afterClosed()
      .pipe(
        switchMap((isSuccess: boolean) => {
          if (isSuccess) {
            this.deleteLegalizationDocumentEvent.emit({ ...legalizationDocument, Files: [file] })
          }
          return of([]);
        }),
      )
      .subscribe();
  }

  private dialogConfig = <Type>(data: Type): MatDialogConfig<Type> => {
    const dialogConfig = new MatDialogConfig<Type>();
    dialogConfig.panelClass = 'document-form-dialog';
    dialogConfig.data = data;
    return dialogConfig;
  };

  private handleDialogResponse(result: any): void {
    if (!result) {
      return;
    }

    if (result.isSuccess) {
      this.subject.next();
      this.newLegalizationDocumentEvent.emit(result.legalizationDocument);
    }
  }
}
